module.exports = __webpack_public_path__ + "media/images/map-bg@3x-7c51eeee71f21e05280533ae4c7e6888.png";